import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class ContractStackItem extends EquatableKeyStackItem {
    asContract() {
        return this.value;
    }
}

//# sourceMappingURL=ContractStackItem.js.map
